import React from 'react';

import { Button } from '@opendoor/bricks/core';

import { ReportDisplay } from '../config/reports';
import { BtnWrap, GhostLink } from '../styles/components';
import { LoadStateLabel } from '../types';

declare let document: any;
const onmessage = (event: any) => {
  if (event.origin === 'https://app.mode.com' && event.data && event.data.id) {
    try {
      document.getElementById(event.data.id).style.height = event.data.height + 'px';
    } catch (e) {
      // ignore
    }
  }
};

const Report = (props: {
  btnText: string;
  displayType: number;
  id: string;
  loading: boolean;
  loadStateLabel: LoadStateLabel;
  onLoadStateChange: (loadStateLabel: LoadStateLabel, isLoaded: boolean) => void;
  url: string;
  hasFullReport: boolean;
  reportId: string;
}) => {
  React.useEffect(() => {
    window.addEventListener('message', onmessage);
    return () => {
      window.removeEventListener('message', onmessage);
    };
  }, []);

  const onLoaded = () => {
    props.onLoadStateChange(props.loadStateLabel, true);
  };

  return (
    <div id={props.id}>
      {props.url !== '' && (
        <iframe
          id={`iframe-${props.id}`}
          title={`iframe-${props.id}`}
          className={props.loading ? 'hidden' : ''}
          src={props.url}
          width="100%"
          frameBorder="0"
          height="1000px"
          onLoad={onLoaded}
        />
      )}
      {props.displayType === ReportDisplay.TABLE && props.hasFullReport && (
        <GhostLink to={`/reports/${props.reportId}-full`}>
          <BtnWrap>
            <Button
              /** TODO @growth Semantic buttons without onClick methods are a11y violations. See https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1943339236/Accessibility+best+practices+for+frontend+development#Adding-onClick-handlers-to-non-interactive-elements-such-as-%3Cdiv-/%3E-or-%3CBox-/%3E-not-started */
              onClick={() => {}}
              /** @ts-expect-error TODO @partnerships Remove border radius override */
              borderRadius="rounded"
              aria-label=""
              analyticsName={`cosmos-view-full-${props.btnText}-report`}
            >{`View full ${props.btnText} report`}</Button>
          </BtnWrap>
        </GhostLink>
      )}
    </div>
  );
};

export default Report;
